<template>
  <div class="camera-item camera-item-pending">
    <svg id='loading-svg' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clip-path="url(#clip0_8550_125367)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.1672 1.66561C9.1672 1.20537 9.54029 0.832275 10.0005 0.832275C15.0631 0.832275 19.1672 4.93633 19.1672 9.99894C19.1672 15.0616 15.0631 19.1656 10.0005 19.1656C4.93792 19.1656 0.833862 15.0616 0.833862 9.99894C0.833862 9.53871 1.20696 9.16561 1.6672 9.16561C2.12743 9.16561 2.50053 9.53871 2.50053 9.99894C2.50053 14.1411 5.85839 17.4989 10.0005 17.4989C14.1427 17.4989 17.5005 14.1411 17.5005 9.99894C17.5005 5.85681 14.1427 2.49894 10.0005 2.49894C9.54029 2.49894 9.1672 2.12585 9.1672 1.66561Z"
          fill="#F60457"
        />
      </g>
      <defs>
        <clipPath id="clip0_8550_125367">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>
<script>
import { defineComponent } from 'vue-demi';
const name = 'pending-image';
export default defineComponent({
  name,
  props: {},
  setup() {
    return {};
  }
});
</script>
<style>
#loading-svg {
  position: absolute;
  z-index: 10;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
  animation: spin 2s linear infinite;
  transform-origin: center center;
}
.camera-item-pending {
  background-color: #F2F2F2;
}
</style>
